module.exports = __webpack_public_path__ + "media/assets/images/flags/mp-bd658c496bccf828d73d8dc99d414711.svg";